export default function SlideLayout({
  eyebrow,
  title,
  intro,
  children,
  footer,
  align = 'left',
  tone = 'canvas',
  contentClassName = '',
}) {
  const titleAlign = align === 'center' ? 'mx-auto text-center' : '';
  const eyebrowTone =
    tone === 'ink' ? 'text-white/55' : tone === 'terracotta' ? 'text-tf-ink/65' : 'text-tf-teal';
  const titleTone = tone === 'ink' ? 'text-white' : 'text-tf-ink';
  const introTone = tone === 'ink' ? 'text-white/75' : 'text-tf-ink/80';
  const footerTone = tone === 'ink' ? 'text-white/55' : 'text-tf-ink/65';

  // Split multi-sentence titles onto separate lines so the visual break lands
  // at a sentence boundary instead of mid-phrase. Single-sentence titles wrap
  // naturally.
  const titleSentences =
    typeof title === 'string'
      ? title
          .split(/(?<=[.!?])\s+/)
          .map((s) => s.trim())
          .filter(Boolean)
      : null;

  return (
    <div className="mx-auto flex h-full w-full max-w-6xl flex-col gap-10 px-4 pb-12 pt-14 sm:gap-12 sm:px-6 sm:pb-16 sm:pt-20 lg:pt-24">
      <header className={`max-w-4xl space-y-4 sm:space-y-5 ${titleAlign}`}>
        {eyebrow ? (
          <p className={`text-[12px] font-medium uppercase tracking-[0.16em] ${eyebrowTone}`}>
            {eyebrow}
          </p>
        ) : null}
        {titleSentences && titleSentences.length > 0 ? (
          <h2
            className={`font-brand text-[34px] font-light leading-[1.05] tracking-[-0.015em] sm:text-[44px] lg:text-[52px] ${titleTone}`}
          >
            {titleSentences.length > 1
              ? titleSentences.map((sentence, idx) => (
                  <span
                    key={`${idx}-${sentence.slice(0, 16)}`}
                    className={idx > 0 ? 'block sm:mt-1' : 'block'}
                  >
                    {sentence}
                  </span>
                ))
              : titleSentences[0]}
          </h2>
        ) : null}
        {intro ? (
          <p
            className={`max-w-3xl text-[17px] font-light leading-[1.6] sm:text-[18px] ${introTone}`}
          >
            {intro}
          </p>
        ) : null}
      </header>

      <div className={contentClassName}>{children}</div>

      {footer ? (
        <footer className={`mt-auto max-w-3xl text-[14px] font-light leading-[1.6] ${footerTone}`}>
          {footer}
        </footer>
      ) : null}
    </div>
  );
}
